var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap login-otp-left-wrap"
  }, [_c('div', {
    staticClass: "back-icon text-start"
  }, [_c('router-link', {
    staticClass: "ms-0 ps-0",
    attrs: {
      "to": "/password-login"
    }
  }, [_vm._v("Back")])], 1), _c('div', {
    staticClass: "left-login"
  }, [_vm._m(0), _c('div', {}, [_c('router-link', {
    attrs: {
      "to": "/smart-login"
    }
  }, [_c('button', {
    staticClass: "qr-login-btn"
  }, [_c('img', {
    staticClass: "me-2",
    attrs: {
      "src": require("../../assets/images/qr-icon.svg"),
      "alt": "qr icon"
    }
  }), _vm._v("Login with QR ")])])], 1)]), _c('h4', {
    staticClass: "login-title mb-1"
  }, [_vm._v("Login to Continue")]), _c('div', {
    staticClass: "auth-form pt-3 pb-3"
  }, [_c('div', {
    staticClass: "email-change-wrap"
  }, [_c('div', {}, [_vm._v(_vm._s(_vm.email))]), _c('div', {
    staticClass: "login-highlight",
    on: {
      "click": _vm.routeToLogin
    }
  }, [_vm._v("Change")])]), _c('form', {}, [_c('div', {
    staticClass: "mt-3"
  }, [_vm._m(1), _c('div', {
    staticClass: "otp-input-wrapper d-flex"
  }, _vm._l(6, function (_, idx) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.digits[idx],
        expression: "digits[idx]"
      }],
      key: idx,
      ref: "inputs",
      refInFor: true,
      staticClass: "otp-input",
      class: {
        'error-border': _vm.otpErrorFlag
      },
      attrs: {
        "type": "tel",
        "maxlength": "1",
        "autocomplete": "one-time-code",
        "disabled": _vm.isLockedOut,
        "aria-label": "OTP digit ".concat(idx + 1)
      },
      domProps: {
        "value": _vm.digits[idx]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) { return; }

          _vm.$set(_vm.digits, idx, $event.target.value);
        }, function ($event) {
          return _vm.handleInput(idx, $event);
        }],
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
          return _vm.handleDelete(idx, $event);
        },
        "paste": function paste($event) {
          $event.preventDefault();
          return _vm.handlePaste.apply(null, arguments);
        },
        "focus": _vm.clearError
      }
    });
  }), 0), _vm.otpErrorFlag && !_vm.isLockedOut ? _c('div', {
    staticClass: "valid-error mt-2"
  }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e()])]), _c('button', {
    staticClass: "submit-btn mt-3 next-btn",
    attrs: {
      "disabled": _vm.formLoader || !_vm.isOtpComplete || _vm.isLockedOut,
      "type": "button"
    },
    on: {
      "click": _vm.verifyToken
    }
  }, [_vm.formLoader ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Login ")], 1), !_vm.isLockedOut ? _c('login-otp', {
    attrs: {
      "expirySecond": 60,
      "setSpinnerLoader": _vm.otpLoader
    },
    on: {
      "sendOTP": _vm.sendOTP
    }
  }) : _vm._e(), _vm.isLockedOut ? _c('lockout-timer', {
    attrs: {
      "lockout-seconds": _vm.lockoutSeconds
    },
    on: {
      "lockout-expired": _vm.handleLockoutExpired
    }
  }) : _vm._e()], 1)])]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('login-in-carsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "image-fluid"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {}, [_c('label', {
    staticClass: "opt-label mt-0"
  }, [_vm._v("Enter OTP"), _c('span', {
    staticClass: "required-label"
  }, [_vm._v("*")])])])]);
}]

export { render, staticRenderFns }